var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tree',{ref:"tree",attrs:{"props":_vm.props1,"load":_vm.loadNode1,"node-key":"id","lazy":"","show-checkbox":"","highlight-current":"","default-expanded-keys":_vm.defaultExpandedKeys,"default-checked-keys":_vm.defaultCheckedKeys},on:{"check-change":_vm.emitNodes}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vue/cli-service/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34b4af80","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/@vue/cli-service/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tree.vue
// module id = null
// module chunks = 